import React from 'react';
import { SUPPORT_EMAIL } from '../constants/support';

/**
 * One line pointing the participant to AfricaNenda's support address.
 * `lead` is the sentence before the address; `subject` pre-fills the email;
 * `body` sets it as body text rather than a footnote.
 */
export default function SupportContact({ lead = 'Need help? Email AfricaNenda at', subject, body = false, className = '' }) {
  const href = `mailto:${SUPPORT_EMAIL}${subject ? `?subject=${encodeURIComponent(subject)}` : ''}`;
  return (
    <p className={`${body ? 'text-sm text-gray-700' : 'text-xs text-gray-500'} ${className}`}>
      {lead}{' '}
      <a href={href} className="text-primary-600 font-medium hover:text-primary-700 break-words">{SUPPORT_EMAIL}</a>.
    </p>
  );
}
